module.exports = "<div class=\"log keys\" \nng-show=\"vm.active\"\nstyle=\"position:relative\">\n  <div ng-repeat=\"key in vm.keys\"\n      ng-class=\"{\n        'white': key.colour === 1, \n        'black': key.colour ===0,\n        'active': key.track\n      }\" \n      style=\"width:{{key.width}}px;left:{{key.left}}px;height:{{key.height}}px\"\n      class=\"key track{{key.track}}\"><div class=\"key-name\">{{key.name}}</div>\n  </div>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/web/main/log/piano-keys.html
// module id = 172
// module chunks = 0